import type { Ref } from "react"
import { OUTLINES, type BodyType } from "./outlines"
import type { Corner } from "./types"

// "This view": a small drawing of a car from the corner asked for, in the
// instruction band (the body type from the VIN, else a sedan). Just a
// picture of the angle, never something to line up with: the camera
// outlines the real car instead. Tapping it shows where to stand.

export function ViewPictogram({
  ref,
  corner,
  body,
  open,
  onToggle,
}: {
  ref?: Ref<HTMLButtonElement>
  corner: Corner
  body: BodyType
  // The "where to stand" sheet it opens is showing.
  open: boolean
  onToggle: () => void
}) {
  const o = OUTLINES[body][corner]
  return (
    <button
      ref={ref}
      type="button"
      onClick={onToggle}
      aria-label="Where to stand"
      aria-expanded={open}
      aria-controls="stand-sheet"
      data-testid="view-pictogram"
      data-body={body}
      className="grid h-11 w-16 shrink-0 place-items-center rounded-xl bg-white/10 ring-1 ring-white/15 hover:bg-white/15 focus-visible:outline-2 focus-visible:outline-white"
    >
      <svg viewBox={`0 0 ${o.viewBox.w} ${o.viewBox.h}`} className="h-7 w-14 overflow-visible" aria-hidden>
        <path d={o.body} fill="none" stroke="white" strokeWidth={1.6} strokeLinejoin="round" vectorEffect="non-scaling-stroke" />
      </svg>
    </button>
  )
}
